// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610210505/js/" + chunkId + "." + {"44":"f5db6873","225":"43cf199e","481":"4db08135","486":"49f2e8e9","770":"dd635d42"}[chunkId] + ".0.9355297523097567.chunk.js";
};